module.exports = window["popupMaker"]["ctaEditor"];